import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dreamWorldProvider from "../../DreamWorldProvider";
import { selectUserGlobalData } from "../../store/dreamworldSlice";
import { LibraryItem } from "../../types/library";
import ContentCard from "../dashboard/ContentCard";
import LoadingIndicator from "../ui/LoadingIndicator";

interface LibrarySelectionModalProps {
  onClose: () => void;
  onSelect: (item: LibraryItem) => void;
}

const LibrarySelectionModal: React.FC<LibrarySelectionModalProps> = ({
  onClose,
  onSelect,
}) => {
  const [libraryItems, setLibraryItems] = useState<LibraryItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(selectUserGlobalData);
  const fetchLibraryItems = useCallback(async () => {
    if (!user) return;
    setIsLoading(true);
    try {
      const items = await dreamWorldProvider.getLibraryContent(
        user.userData?.uid
      );
      setLibraryItems(items.items || []);
    } catch (error) {
      console.error("Error fetching library items:", error);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchLibraryItems();
  }, [fetchLibraryItems]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">
            Select from your Library
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            &times;
          </button>
        </div>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {libraryItems.map((item) => (
              <div key={item.id} onClick={() => onSelect(item)}>
                <ContentCard
                  item={item}
                  onLike={() => {}}
                  onClick={() => onSelect(item)}
                  viewMode="grid"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LibrarySelectionModal;
